'use client';

import { useCallback, useRef } from 'react';

import { Dialog } from '@/app/components/Dialog';
import { ChatHeader } from './ChatWindowHeader';
import { ChatWindow, type ChatWindowHandle } from '@/app/chat/ChatWindow';
import { FiX } from 'react-icons/fi';
import { cn } from '@/utils/uiUtils';
import { useCalendarState } from '@/app/calendar/utils/useCalendarState';

export default function ChatModal() {
  const { showChatWindow, setShowChatWindow } = useCalendarState();
  const chatWindowRef = useRef<ChatWindowHandle>(null);
  const refreshMessages = useCallback(() => {
    return chatWindowRef.current?.refreshMessages() ?? Promise.resolve();
  }, []);

  const closeButton = (
    <button
      className={cn(['btn p-4 bg-transparent', showChatWindow ? 'active' : ''])}
      onClick={() => setShowChatWindow(false)}
    >
      <FiX className='w-4 h-4 md:w-5 md:h-5' />
    </button>
  );

  return (
    <div className='h-full bg-gradient-radial from-gray-200 to-gray-500 dark:from-gray-900 dark:to-gray-700'>
      <Dialog
        dismissible={true}
        show={showChatWindow}
        onClose={() => setShowChatWindow(false)}
        className='h-[calc(100vh-2rem)]'
        unmount={false}
      >
        <Dialog.Header className='flex items-center justify-between gap-4 relative p-0'>
          <div
            className={cn([
              'w-full flex-0 flex justify-between',
              'bg-gradient-to-b from-slate-400 to-slate-300 dark:from-slate-600 dark:to-slate-500',
            ])}
          >
            <ChatHeader refreshMessages={refreshMessages} />
            {closeButton}
          </div>
        </Dialog.Header>
        <ChatWindow
          ref={chatWindowRef}
          endpoint='/api/chat/coach'
          showHeader={false}
        />
      </Dialog>
    </div>
  );
}
